import { ActionContext } from 'vuex'
import apiAdminCoverageIteration from '@/api/admin/coverageIteration'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { ICoverageIterationState } from './state';
import { ApiResultCode } from '@/models/response/AlrBase';
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration';
import { AloError } from '@/models/alo/AloError';
import { AloBaseArray } from '@/models/alo/AloBaseArray';
import { router } from '@/mainjs.js'
import { CoverageState } from '@/enum/CoverageState'
import { nextTick } from 'vue'
import {i18n} from '@/locale/vueI18n'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { MissionGlobalType } from '@/enum/MissionGlobalType'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'

export class CoverageIterationAction {
   
  public [types.COVERAGEITERATION_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>) {    
    return new Promise((resolve, reject) => {
        context.commit(types.COVERAGEITERATION_REQUEST)
        apiAdminCoverageIteration
          .getCoverageIterations()
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const coverageIterationArray = resp.data.data as AloBaseArray<AloDbCoverageIteration>
              context.commit(types.COVERAGEITERATION_SUCCESS, coverageIterationArray.items)
              resolve(coverageIterationArray.items)
            } else {
              context.commit(types.COVERAGEITERATION_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(resp => {
            context.commit(types.COVERAGEITERATION_ERROR)
            reject()
          })
      })
  }

  public [types.COVERAGEITERATION_ENSURE_LIST](context: ActionContext<ICoverageIterationState, IRootState>) {
    if(context.state.coverageIterations.length == 0) {
        return context.dispatch(types.COVERAGEITERATION_REQUEST)
    }
    else {
        return new Promise((resolve, reject) => {            
            resolve(context.state.coverageIterations)            
        })
    }    
  }

  public [types.COVERAGEITERATION_SELECT_DETAIL](context: ActionContext<ICoverageIterationState, IRootState>, itemId:number) {        
    return new Promise((resolve, reject) => {
      const coverageIteration = context.getters.coverageIterationsById[itemId] as AloDbCoverageIteration            
      if(coverageIteration?.id) {
        //on copie la config courante sur celle de la mission global                
        context.rootState.ui.hideMap = true
        nextTick(()=> {    
          context.rootGetters.modifiedAdmMissionGlobal
          context.rootGetters.modifiedAdmMissionGlobal.config = {...AloDbMissionGlobal.parseSmartSimulation(coverageIteration.COV_PARAM_JSON,MissionGlobalType.COVERAGE),templateSimId:context.rootGetters.modifiedAdmMissionGlobal?.config?.templateSimId ?? null}
          context.rootGetters.modifiedAdmMissionGlobal.resultGridJson = coverageIteration.resultGridJson                  

          const coverageState = context.rootGetters.coverageStateByUiid(buildCoverageStateId(context.rootGetters.modifiedAdmMissionGlobal.MIG_ID!,"detail"))            
          coverageState.selectedCoverageId = coverageIteration.id
          nextTick(()=>context.rootState.ui.hideMap = false)
          setTimeout(()=>  {              
            context.dispatch(types.UI_REFRESH_BEST_FIT_MAP,buildSimulationUIStateId(context.rootGetters.modifiedAdmMissionGlobal.MIG_ID!,"map"))
            resolve(coverageIteration)
          },500)
        })
      }    
      else{
        resolve(null)
      }
      
      // if(coverageIteration) {        
      //   if(coverageIteration.detailLoaded) {
      //     context.commit(types.COVERAGEITERATION_SELECT_DETAIL,coverageIteration)
      //     resolve(coverageIteration)
      //   }
      //   else{
      //     context.dispatch(types.COVERAGEITERATION_SELECT_DETAIL_REQUEST,itemId).then((ens) => {
      //       context.commit(types.COVERAGEITERATION_SELECT_DETAIL,ens)
      //       resolve(ens)
      //     })
      //   }
      // }    
      // else{
      //   const newCoverageIteration = new AloDbCoverageIteration()
      //   context.commit(types.COVERAGEITERATION_SELECT_DETAIL,newCoverageIteration)
      //   resolve(newCoverageIteration)
      // }
    })
  }

  public [types.COVERAGEITERATION_SELECT_DETAIL_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>, itemId:number) {
    return new Promise((resolve, reject) => {
        context.commit(types.COVERAGEITERATION_SELECT_DETAIL_REQUEST, itemId)
        apiAdminCoverageIteration
          .getCoverageIteration(itemId)
          .then(resp => {            
            if (resp.data.resultCode == ApiResultCode.Ok) {
              //lance la creation des models de mission state Ui si necessaire
              const coverageIteration = resp.data.data as AloDbCoverageIteration
              const index = context.state.coverageIterations.findIndex(m => m.COV_ID == coverageIteration.COV_ID)                
              context.rootState.ui.hideMap = true              
              nextTick(()=> {
                context.commit(types.COVERAGEITERATION_SELECT_DETAIL_SUCCESS, coverageIteration)
                nextTick(()=>context.rootState.ui.hideMap = false)
              })
              
              context.commit(types.COVERAGEITERATION_SELECT_DETAIL,coverageIteration)
              resolve(coverageIteration)
            } else {
              context.commit(types.COVERAGEITERATION_SELECT_DETAIL_ERROR)
              reject(resp.data.data as AloError)
            }
          })
          .catch(() => {
            context.commit(types.COVERAGEITERATION_SELECT_DETAIL_ERROR)
            reject()
          })
      })
  }

  public [types.COVERAGEITERATION_SAVE_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>) {    
    return new Promise((resolve, reject) => { 
        const tryRedirect = !context.state.modifiedAdmCoverageIteration.id
        context.commit(types.COVERAGEITERATION_SAVE_REQUEST,context.state.modifiedAdmCoverageIteration.COV_LIBELLE)
        apiAdminCoverageIteration
          .saveCoverageIteration(context.state.modifiedAdmCoverageIteration)                    
          .then(resp => {                                
            if (resp.data.resultCode == ApiResultCode.Ok) {
              const coverageIteration = resp.data.data as AloDbCoverageIteration            
              context.commit(types.COVERAGEITERATION_SELECT_DETAIL_SUCCESS, coverageIteration)
              context.commit(types.COVERAGEITERATION_SELECT_DETAIL,coverageIteration) 
              context.dispatch("UI_ADD_SNACK_MESSAGE",`La coverageIteration ${coverageIteration.COV_LIBELLE} a été correctement sauvegardée`)              
              if(tryRedirect && router.app.$route.name === 'NewCoverageIteration') router.push({name:'EditCoverageIteration',params:{coverageIterationid:coverageIteration.id!.toString()}})
              resolve(coverageIteration)
              
            } else {
              console.error("ATTENTION une reponse Code 200 contient une erreur")
              context.commit(types.COVERAGEITERATION_SAVE_ERROR)
              const error = resp.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",`Erreur lors de la sauvegarde : ${error.errorMessage}`)              
              console.error(error)
              reject(error)
            }
          })          
          .catch((error) => {
            context.commit(types.COVERAGEITERATION_SAVE_ERROR)
            if(error.response){
              const er = error.response.data.data as AloError              
              context.dispatch("UI_ADD_SNACK_MESSAGE",`Erreur lors de la sauvegarde : ${er.errorMessage}`)
              console.error(er)
              reject(er)
            }   
            else{         
              context.dispatch("UI_ADD_SNACK_MESSAGE","Erreur lors de la sauvegarde")
              reject()
            }            
          })
      })
  }

  public [types.COVERAGEITERATION_UPDATE_MODIFIED_ADM](context: ActionContext<ICoverageIterationState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.COVERAGEITERATION_UPDATE_MODIFIED_ADM,newProperties)
      resolve(context.state.modifiedAdmCoverageIteration)
    })
  }
  
  public [types.COVERAGEITERATION_CANCEL_MODIFIED_ADM](context: ActionContext<ICoverageIterationState, IRootState>) {        
    return new Promise((resolve, reject) => {
      context.commit(types.COVERAGEITERATION_SELECT_DETAIL,context.state.originalAdmCoverageIteration)
      resolve(context.state.modifiedAdmCoverageIteration)
    })
  }

  public [types.COVERAGEITERATION_UPDATE_FILTER_ADM](context: ActionContext<ICoverageIterationState, IRootState>, newProperties:Object) {        
    return new Promise((resolve, reject) => {
      context.commit(types.COVERAGEITERATION_UPDATE_FILTER_ADM,newProperties)
      resolve(context.state.adminFilter)
    })
  }


  public [types.COVERAGEITERATION_PROGRESSION_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>, {itemId,migTyp}:{itemId:number,migTyp:number|null}) {
      return new Promise<void>((resolve, reject) => {
          //context.commit(types.COVERAGEITERATION_PROGRESSION_REQUEST, itemId)
          const funcResult = (migTyp == MissionGlobalType.FORMATION) ? apiAdminCoverageIteration.getFormationResult : apiAdminCoverageIteration.getCoverageResult
          funcResult(itemId)
            .then(resp => {   
              //on re recupere la coverageIteration pour la mettre à jour     
              const coverageIteration = context.getters.coverageIterationsById[itemId] as AloDbCoverageIteration                                                                 
              if (resp.data.resultCode == ApiResultCode.Ok) {                                                     
                context.dispatch(types.COVERAGEITERATION_SELECT_DETAIL_REQUEST,itemId).then(() => {
                  resolve()
                })
                // const fakeWob = {
                //   irisRawResult:JSON.stringify(resp.data.data),
                //   irisResult:resp.data.data,
                //   misId:itemId
                // }        
                // context.dispatch(types.MISSIONVIRTUAL_UPDATE_PROGRESSION, fakeWob)              
                // context.dispatch(types.MISSION_ENDMISSION_UPDATE_PROGRESSION, fakeWob)
                
              } else {
                context.commit(types.COVERAGEITERATION_PROGRESSION_ERROR)
                
                if(coverageIteration) {                  
                  coverageIteration.COV_PROCESSING_STATE = CoverageState.finished
                  apiAdminCoverageIteration.saveCoverageIteration(coverageIteration)      
                }                              
                
                reject(resp.data.data as AloError)
              }
            })
            .catch(() => {
              const coverageIteration = context.getters.coverageIterationsById[itemId] as AloDbCoverageIteration
              if(coverageIteration) {                  
                coverageIteration.COV_PROCESSING_STATE = CoverageState.finished
                apiAdminCoverageIteration.saveCoverageIteration(coverageIteration)      
              }  
                      
              //TODO Ajouter eventuellement une erreur
              context.commit(types.COVERAGEITERATION_PROGRESSION_ERROR)
              reject()
            })
        })
    }


  public [types.COVERAGEITERATION_DELETE_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>,covIteration:AloDbCoverageIteration) {
      return new Promise<void>((resolve, reject) => {      
        const covId = covIteration?covIteration.id!:context.state.originalAdmCoverageIteration.id!
        const covLabel = covIteration?covIteration.COV_LIBELLE:context.state.originalAdmCoverageIteration.COV_LIBELLE          
  
        context.commit(types.COVERAGEITERATION_DELETE_REQUEST, covLabel)
        apiAdminCoverageIteration
          .deleteCoverageIteration(covId)
          .then(resp => {
            if (resp.data.resultCode == ApiResultCode.Ok) {
              context.commit(types.COVERAGEITERATION_DELETE_SUCCESS, covId)            
              resolve()
            } else {
              console.error('ATTENTION une reponse Code 200 contient une erreur')
              context.commit(types.COVERAGEITERATION_DELETE_ERROR)
              const error = resp.data.data as AloError
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:error.errorMessage}))
              console.error(error)
              reject(error)
            }
          })
          .catch(error => {
            context.commit(types.COVERAGEITERATION_DELETE_ERROR)
            if (error.response) {
              const er = error.response.data.data as AloError
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorDelete',{error:er.errorMessage}))
              console.error(er)
              reject(er)
            } else {
              context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.ErrorOnDelete'))
              reject()
            }
          })
      })
    }

    public [types.COVERAGEITERATION_ENSURE_DATA_SCIENCE](context: ActionContext<ICoverageIterationState, IRootState>, {covId,gliderKey}:{covId:number,gliderKey:string}) {
      const coverageIteration = context.getters.coverageIterationsById[covId] as AloDbCoverageIteration    
      if (!(coverageIteration?.resultAloMission?.[gliderKey]._dataScienceLoaded ?? false)) {
        return context.dispatch(types.COVERAGEITERATION_DATA_SCIENCE_REQUEST, {id:covId,gliderKey,targetYosCycles:null})
      } else {
        return new Promise((resolve, reject) => {
          if (!coverageIteration?.resultAloMission?.[gliderKey]) {  
            reject()
          } else {
            resolve(coverageIteration?.resultAloMission?.[gliderKey].dataScience)
          }
        })
      }
    }

     public [types.COVERAGEITERATION_DATA_SCIENCE_REQUEST](context: ActionContext<ICoverageIterationState, IRootState>,  {id,gliderKey,targetYosCycles}:{id:number,gliderKey:string,targetYosCycles:Array<number>|null})  {    
        return new Promise((resolve, reject) => {      
          context.commit(types.COVERAGEITERATION_DATA_SCIENCE_REQUEST, {id,gliderKey}) 
          apiAdminCoverageIteration
            .getDataScience(id,gliderKey,targetYosCycles)
            .then(resp => {          
              if (resp.data.resultCode == ApiResultCode.Ok) {
                const datas = resp.data.data
                //context.commit les données de la mission
                context.commit(types.COVERAGEITERATION_DATA_SCIENCE_SUCCESS, { id, gliderKey, datas, targetYosCycles })
                resolve(datas)
              } else {
                context.commit(types.COVERAGEITERATION_DATA_SCIENCE_ERROR,  {id,gliderKey})
                reject()
              }
            })
            .catch(error => {
              context.commit(types.COVERAGEITERATION_DATA_SCIENCE_ERROR,  {id,gliderKey})
              reject()
            })
        })
      }
}

export default util.classToObject(CoverageIterationAction)